<template>
  <LoaderIcon v-if="loading" />
  <div v-if="!loading">
    <p class="text-gray-600 mb-2">{{ balance.amount }} руб.</p>
    <p class="text-gray-600 mb-2">хватит на - дн.</p>
    <button class="px-4 py-2 mt-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors cursor-pointer">
      Пополнить
    </button>
  </div>
</template>

<script>
import LoaderIcon from "@/components/LoaderIcon.vue";

export default {
  name: 'BalanceBlock',
  components: {LoaderIcon},
  data() {
    return {
      balance: null,
      error: null,
      loading: true
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    //
  },
  methods: {
    loadData: function () {
      console.log("load tariff")
      let c = this;
      c.balance = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/profile/balance').then(function(response) {
        c.balance = response.data.data;
      }).catch(function(err) {
        console.log("TARIFF", err, err.response.data.error);
        c.error = true;
        if (typeof err.response.data.error === "string") {
          c.error = err.response.data.error;
        }
      }).finally(function() {
        c.loading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
